import { SearchItemType } from '@/types/api'

import { getServiceUrl, selectAPIService } from '@/app/_utils/select-api-service'

export async function sendCardDataClickEvent(
    userToken: string,
    id: string | null,
    queryId: string,
    type: SearchItemType | null,
    position: number | null
) {
    const apiService = selectAPIService()
    const baseUrl = getServiceUrl(apiService.ntl)

    const data = {
        userToken,
        docId: id,
        queryId,
        type: type,
        position,
    }
    const blob = new Blob([JSON.stringify(data)], { type: 'application/json' })

    if ('sendBeacon' in navigator) {
        navigator.sendBeacon(`${baseUrl}/stats/catalog/click`, blob)
    }
}
